import { Button, Divider } from 'antd';
import { commonApi } from 'api/commonApi';
import AddEditFormWeather from 'components/Common/Modal/AddEditFormWeather';
// import { deviceApi } from 'api/device';
import { inverterInfo, objectDevice } from 'models';
import * as React from 'react';
import style from './NotEnvironmentInfo.module.scss';
export interface NotEnvironmentInfoProps {
  paramId: string | null;
  setEnvironment: (object: inverterInfo | undefined) => void;
}

export default function NotEnvironmentInfo(props: NotEnvironmentInfoProps) {
  const { paramId, setEnvironment } = props;
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const [SensorType, setSensorType] = React.useState<objectDevice[]>();
  const isEvent: boolean = false;

  React.useEffect(() => {
    (async () => {
      const res = await commonApi.fetchDeviceProfile({
        text_search: 'Weather',
        _limit: 600,
        _page: 0,
      });
      setSensorType(res.data);
    })();
  }, [paramId]);

  const showModal = () => {
    setIsModalVisible(!isModalVisible);
  };
  return (
    <div className={style.not_environment}>
      <div className={style.label_environment}>
        <Divider orientation="left" plain style={{ fontWeight: 'bold', fontSize: '18px' }}>
          Weather sensor
        </Divider>
      </div>
      <div className={style.content_not_environment}>
        There is no weather sensor
        <Button
          type="primary"
          size="middle"
          shape="round"
          style={{ backgroundColor: '#4DC367', marginLeft: '20px' }}
          onClick={showModal}
        >
          Add sensor
        </Button>
      </div>
      {SensorType && (
        <AddEditFormWeather
          setEnvironment={setEnvironment}
          SensorType={SensorType}
          isEvent={isEvent}
          itemInverter={undefined}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
        />
      )}
    </div>
  );
}
